import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Play, Pause, Headphones } from "lucide-react";
import api from "../lib/api";
import { usePlayer } from "../context/PlayerContext";
import { Loading } from "../components/Layout";
import CoverImage from "../components/CoverImage";

export default function Library() {
  const nav = useNavigate();
  const { current, isPlaying, play } = usePlayer();
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/library").then((r) => setItems(r.data));
  }, []);

  if (items === null) return <Loading />;

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12 animate-fade-up">
      <h1 className="font-display text-4xl mb-8">Your library</h1>
      {items.length === 0 ? (
        <div className="text-center py-24 text-muted-foreground">
          <Headphones size={40} strokeWidth={1.25} className="mx-auto mb-4 opacity-50" />
          <p>You haven't unlocked any episodes yet.</p>
          <button onClick={() => nav("/")} className="mt-4 text-primary hover:underline">Discover stories</button>
        </div>
      ) : (
        <div className="space-y-2" data-testid="library-list">
          {items.map((ep) => {
            const active = current?.episode.id === ep.id;
            return (
              <div key={ep.id} className={`flex items-center gap-4 rounded-lg border p-4 transition-colors duration-300 ${active ? "border-primary/50 bg-primary/5" : "border-white/5 bg-card/40 hover:bg-card/70"}`}>
                <div className="h-12 w-12 rounded overflow-hidden bg-secondary shrink-0">
                  {ep.cover_url && (
                    <CoverImage
                      coverUrl={ep.cover_url}
                      alt=""
                      data-testid={`library-cover-${ep.id}`}
                      className="h-full w-full object-cover"
                    />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium truncate">{ep.title}</p>
                  <p className="text-xs text-muted-foreground truncate">{ep.story_title}</p>
                </div>
                <button
                  data-testid={`library-play-${ep.id}`}
                  onClick={() => play(ep, { storyTitle: ep.story_title, cover: ep.cover_url })}
                  className="h-10 w-10 rounded-full bg-primary hover:bg-primary/90 flex items-center justify-center shadow-[0_0_12px_rgba(155,27,48,0.35)] transition-colors duration-300 shrink-0"
                >
                  {active && isPlaying ? <Pause size={15} fill="currentColor" /> : <Play size={15} fill="currentColor" className="ml-0.5" />}
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
